import { LitElement, css, html } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import '@jack-henry/jh-ui/components/progress/progress.js';

@customElement('circle-loader')
class Loader extends LitElement {
  @query('dialog') private dialog!: HTMLDialogElement;

  static readonly styles = css`
    :host {
      display: contents;
    }
    dialog {
      border: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      background: transparent !important;
      background-color: transparent !important;
      box-shadow: none !important;
      color: inherit;
      color-scheme: inherit;
      overflow: visible;
      inset: 0;
      width: 100vw;
      height: 100vh;
      max-width: 100vw;
      max-height: 100vh;
      display: grid;
      place-items: center;
      cursor: wait;
    }
    dialog::backdrop {
      background: rgba(0, 0, 0, 0.12);
      cursor: wait;
    }
  `;

  firstUpdated() {
    if (this.dialog && !this.dialog.open) {
      this.dialog.showModal();
    }
  }

  private onCancel(e: Event) {
    e.preventDefault();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  render() {
    return html`
      <dialog @cancel=${this.onCancel} aria-label="Loading" aria-busy="true">
        <jh-progress type="circular" size="large" indeterminate></jh-progress>
      </dialog>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'circle-loader': Loader;
  }
}
